import type { ArenaCard as Card, Character } from '@guildrise/shared';

export function ArenaCard({
  card,
  character,
  zone,
  selected = false,
  dimmed = false,
  secret = false,
  order,
  onClick,
  disabled = false,
  label,
}: {
  readonly card: Card;
  readonly character: Character | undefined;
  readonly zone: number;
  readonly selected?: boolean;
  readonly dimmed?: boolean;
  readonly secret?: boolean;
  readonly order?: number | undefined;
  readonly onClick: () => void;
  readonly disabled?: boolean;
  readonly label?: string;
}) {
  return (
    <button
      type="button"
      data-card-id={card.id}
      className={`arena-card${selected ? ' arena-card--selected' : ''}${dimmed ? ' arena-card--dim' : ''}`}
      onClick={onClick}
      disabled={disabled}
      aria-label={
        label ??
        `${character?.name ?? card.characterId}, влияние ${card.influence}, зона ${zone + 1}${secret ? ', Секрет' : ''}${order !== undefined ? `, выбран ${order + 1}` : ''}`
      }
      aria-pressed={label ? undefined : selected}
    >
      <span className="arena-card__portrait">
        {card.influence > 1 && <span className="arena-card__power tabular">{card.influence}</span>}
        <img
          className="arena-card__art"
          src={`/art/cards/${character?.art ?? card.characterId}-360.webp`}
          alt=""
          draggable={false}
        />
        <img
          className="arena-card__frame"
          src={`/art/rarity-frames/${character?.rarity ?? 'rare'}.svg`}
          alt=""
          draggable={false}
        />
        <span className={`arena-card__zone arena-zone-${zone}`}>{secret ? 'С' : zone + 1}</span>
        {order !== undefined && <span className="arena-card__order">{order + 1}</span>}
      </span>
      <span className="arena-card__name">{character?.name ?? card.characterId}</span>
    </button>
  );
}
